import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  inject,
  effect,
} from "@angular/core";
import { BacDashboardInformation } from "../../../../core/models/dashboard-poc/bacDashboardInformation";
import { DashbaordPocAdditionalFilters } from "../../../../core/models/common/dashboardPocAdditionalFilters.dto";
import { SharedService } from "../../../../core/services/shared.service";

import { ChartModule } from "primeng/chart";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-bac-orders-breakdown-chart",
  templateUrl: "./bac-orders-breakdown-chart.component.html",
  styleUrls: ["./bac-orders-breakdown-chart.component.scss"],
  imports: [ChartModule, CommonModule],
})
export class BacOrdersBreakdownChartComponent implements OnInit, OnChanges {
  @Input()
  bacDashboardInformation: BacDashboardInformation[] = [];
  data!: {
    labels: string[];
    datasets: {
      label: string;
      backgroundColor: string;
      borderColor: string;
      data: number[];
    }[];
  };
  options!: {
    indexAxis: string;
    maintainAspectRatio: boolean;
    aspectRatio: number;
    plugins: {
      legend: {
        labels: {
          color: string;
        };
      };
    };
    scales: {
      x: {
        ticks: {
          color: string;
          font: {
            weight: number;
          };
        };
        grid: {
          color: string;
          drawBorder: boolean;
        };
      };
      y: {
        ticks: {
          color: string;
        };
        grid: {
          color: string;
          drawBorder: boolean;
        };
      };
    };
  };

  @Input()
  dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters =
    {} as DashbaordPocAdditionalFilters;

  @Input() fromComponent = "";

  @Output() closeSalesOrderModel = new EventEmitter<true>();
  @Output() openOrderListingModalEvent = new EventEmitter<boolean>();

  private sharedService = inject(SharedService);
  bgColor!: string;

  constructor(private _sharedService: SharedService) {
    effect(() => {
      const currentTheme = this.sharedService.getTheme()();
      this.bgColor = currentTheme === "dark" ? "#212630" : "#FFFFFF";
      this.ngOnInit();
    });
  }

  ngOnChanges(): void {
    this.ngOnInit();
  }

  ngOnInit() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--p-h2color-color");
    const textColorSecondary =
      documentStyle.getPropertyValue("--p-h2color-color");
    const surfaceBorder = documentStyle.getPropertyValue("--p-h2color-color");

    const labels = this.bacDashboardInformation.map(x => x.supportBreakDown);
    const data = this.bacDashboardInformation.map(x => x.orderCount);

    this.data = {
      labels: labels,
      datasets: [
        {
          label: "BAC",
          backgroundColor: documentStyle.getPropertyValue("--blue-500"),
          borderColor: documentStyle.getPropertyValue("--blue-500"),
          data: data,
        },
      ],
    };

    this.options = {
      indexAxis: "y",
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500,
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };
  }

  closeOrderListingModal() {
    this.closeSalesOrderModel.emit(true);
    this.openOrderListingModalEvent.emit(false);
  }

  GetBacDashboardLabels() {
    // const titles = this.bacDashboardInformation.map((item) => {
    //   return item.supportBreakDown;
    // });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectData(obj: any) {
    const additionalFiltersObj =
      this._sharedService.getDashbaordPocAdditionalFiltersObject();

    const fromDate = this.formatDateToISO(additionalFiltersObj?.fromDate) ??
                     additionalFiltersObj?.fromDate ??
                     "";
    const toDate = this.formatDateToISO(additionalFiltersObj?.toDate) ??
                   additionalFiltersObj?.toDate ??
                   "";

    const dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters = {
      additionalFilters: true,
      bacNumber:
        this.fromComponent == "bac-report"
          ? additionalFiltersObj?.brandingConsultant
          : this.bacDashboardInformation[obj.element.index].bcNumber,
      brandingConsultant:
        this.fromComponent == "bac-report"
          ? this.bacDashboardInformation[obj.element.index].bcNumber
          : additionalFiltersObj?.brandingConsultant,
      fromDate: fromDate,
      toDate: toDate,
      // Only include orderCreatedDateFilterCriteria if both dates are present
      orderCreatedDateFilterCriteria: (fromDate && toDate) ? "between" : "",
    } as DashbaordPocAdditionalFilters;
    this._sharedService.setDashbaordPocAdditionalFiltersObject(
      dashbaordPocAdditionalFilters
    );
    this.openOrderListingModalEvent.emit(true);
    // this._router.navigate(['orders/orderslist/1']);
  }

  private formatDateToISO(dateString: string | undefined): string {
    if (!dateString) {
      return "";
    }

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return "";
      }
      return date.toISOString();
    } catch (error) {
      console.error("formatDateToISO: Error parsing date:", error);
      return "";
    }
  }

  openOrderListingModal(flag: boolean) {
    this.openOrderListingModalEvent.emit(flag);
  }
}
